import React from 'react'
import useQueryAnnounceListMonthly from '../../../../hooks/api/announce/useQueryAnnounceListMonthly'
import Text from '../../../../components/text/Text'
import TableHeader from '../../../../components/table/TableHeader'
import TableItem from '../../../../components/table/TableItem'

interface IProps {
    className?: string
}

const CopyTradingMonthlyData: React.FC<IProps> = ({className}) => {
    const {data} = useQueryAnnounceListMonthly()

    const renderDate = when => {
        const date = String(when)
        const year = date?.substring(0, 4)
        const month = date?.substring(4, 6)

        return `${year}.${month}`
    }
    return (
        <div>
            <TableHeader className={'grid-cols-5 gap-x-[15px]'}>
                <Text>Date</Text>
                <Text>Amount</Text>
                <Text>Count</Text>
                <Text>Paid Amount</Text>
                <Text>Paid Amount</Text>
            </TableHeader>
            {data?.data?.map(item => (
                <TableItem className={'grid-cols-5 gap-x-[15px]'}>
                    <Text>{renderDate(item?.when)}</Text>
                    <Text className={'text-ti2'}>$ {item?.month_amount}</Text>
                    <Text className={'text-ti2'}>{item?.month_count}</Text>
                    <Text className={'text-ti2 text-font_green'}>$ {item?.month_paid_amount}</Text>
                    <Text className={'text-ti2 text-font_green'}>{item?.month_paid_count}</Text>
                </TableItem>
            ))}
        </div>
    )
}

export default CopyTradingMonthlyData
